export default {
	roleFieldValidationError: "Invalid user role.",
	emailFieldValidationError1: "A valid email address is required.",
	emailFieldValidationError2: "It seems you are already in this 1:1. Invite someone else?",
	openNewOneOnOneDialogError: "Failed to open the new one-on-one dialog: {message}",
	submitNewOneOnOneDialogError: "Failed to save the one-on-one: {message}",
	unknownError: "Oops! I had trouble with that: {message}",
};
